module.exports = __webpack_public_path__ + "img/slide-1-mob.f571448.webp";